import * as React from "react";
import { useElementSize } from "../../../hooks/useElementSize";
import { UpDownArrow } from "./arrow";

export const Accordion = ({
    children,
    title,
    active,
    className,
    titleClassName,
    contentClassName
}: {
    children: React.ReactNode;
    title: string;
    active?: boolean;
    className?: string;
    titleClassName?: string;
    contentClassName?: string;
}) => {
    const [isActive, setIsActive] = React.useState(active || false);
    const contentRef = React.useRef(null);
    const height = useElementSize({ ref: contentRef, useHeight: true });
    return (
        <div>
            <div
                className={`flex cursor-pointer items-baseline justify-between ${className}`}
                onClick={() => setIsActive(!isActive)}
            >
                <span className={`${titleClassName}`}>{title}</span>
                <UpDownArrow headingDown={!isActive}></UpDownArrow>
            </div>
            <div
                className={`relative transition-[max-height] overflow-y-hidden ${contentClassName}`}
                style={{ maxHeight: isActive ? height : 0 }}
            >
                <div
                    ref={contentRef}
                    className={`transition-opacity duration-300 ${
                        isActive ? "opacity-100" : "opacity-0"
                    }`}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};
